export enum EAssetTypes {
    VIDEO = 'asset_video',
    AUDIO = 'asset_audio',
    IMAGE = 'asset_image',
}

export default EAssetTypes;



// WEBPACK FOOTER //
// /usr/src/app/src/app/config/AssetsType.ts